import React, { Component } from 'react'
import moment from 'moment';
import { GenericTable } from '../index'
import { ApiClient } from "../../libs/apiClient";
let apiClient = ApiClient.getInstance();


const headers = [
    { title: "Código" },
    { title: "Importe minimo" },
    { title: "Tipo" },
    { title: "Valor" },
    { title: "Desde" },
    { title: "Hasta" },
    { title: "ACCIONES" },
];

class SettingsAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeParam: -1
            , valueParam: 0
            , toDateParam: moment().format("YYYY-MM-DD")
            , minimum: 0
            , data: []
        };
    }

    componentDidMount = () => {
        this.GetReferSysPromo()
    }

    ChangeStateField = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    //  READ
    GetReferSysPromo = async () => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getReferSysPromo();
        enableSpinner(false);


        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }

        this.setState({
            data: responseApi.data || []
        })
    }


    // CREATE
    ValidateFields = () => {
        const { showAlert } = this.props;
        const { typeParam, valueParam, minimum } = this.state

        if (Number(typeParam) === -1) {
            showAlert({ type: "warning", message: `Debe de seleccionar el tipo de la regla` });
            return false;
        }
        if (Number(valueParam) === 0) {
            showAlert({ type: "warning", message: `Debe de insertar el ${Number(typeParam) === 1 ? 'importe' : 'porcentaje'} de la regla` });
            return false;
        }

        if (Number(minimum) === 0) {
            showAlert({ type: "warning", message: `Debe de insertar el importe de venta minimo` });
            return false;
        }

        return true;
    }

    CreateReferSysPromo = async () => {
        const { enableSpinner, showAlert } = this.props;
        const { typeParam, valueParam, toDateParam, minimum } = this.state
        if (!this.ValidateFields()) return

        const data = {
            typeParam,
            valueParam,
            toDateParam,
            minimum
        }

        enableSpinner(true);
        const responseApi = await apiClient.createReferSysPromo(data);
        enableSpinner(false);


        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }

        showAlert({ type: "success", message: `${responseApi.message}` });

        await this.setState({
            typeParam: -1
            , valueParam: 0
            , toDateParam: moment().format("YYYY-MM-DD")
            , minimum: 0
        })
        this.GetReferSysPromo()
    }


    DeleteReferSysPromo = async (register) => {
        const { enableSpinner, showAlert } = this.props;
        if (!register.IdRFSP) return
        const data = {
            ID: register.IdRFSP,
        }

        enableSpinner(true);
        const responseApi = await apiClient.deleteReferSysPromo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        showAlert({ type: "success", message: `${responseApi.message}` });

        this.GetReferSysPromo()
    }

    render() {
        const { typeParam } = this.state
        return (
            <>
                <div className="row">
                    <div className="col-12 h5"> <i className="fas fa-filter mr-2" /> Configuraciones generales </div>
                    <div className="col-12 col-md-6 col-lg-3 col-xl-5 mb-3">
                        <div className="input-group">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Importe de venta mínimo</span>
                                <span className="d-inline d-xl-none">Venta mín.</span>
                            </span>
                            <input type="number"  className="form-control"
                                onChange={(event) => this.ChangeStateField('minimum', event.target.value)}
                                value={this.state.minimum ?? -1}
                            />
                                <span className="input-group-text font-weight-bold">
                                    SOL
                                </span>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 col-xl-2 mb-3">
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 col-xl-2 mb-3">
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <label htmlFor="sWhsCode" className="input-group-text font-weight-bold"> Tipo </label>
                            </div>
                            <select
                                className="form-control"
                                value={typeParam ?? -1}
                                onChange={({ target: { value } }) => this.ChangeStateField("typeParam", value)} >
                                <option value={-1}> Seleccione una opcion </option>
                                <option value={1}> Importe fijo </option>
                                <option value={2}> Porcentaje </option>
                            </select>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 col-xl-4 mb-3">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Valor</span>
                            </div>
                            <input type="text" className="form-control"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                onChange={(event) => this.ChangeStateField('valueParam', event.target.value)}
                                value={this.state.valueParam}
                            />
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    {Number(typeParam) === 1 ? 'SOL' : Number(typeParam) === 2 ? '%' : '--'}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 col-xl-2 mb-3">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <label htmlFor="iDateFrom" className="input-group-text font-weight-bold"> Hasta </label>
                            </div>
                            <input
                                id="iDateFrom"
                                className="form-control"
                                type="date"
                                value={this.state.toDateParam ?? new Date()}
                                onChange={({ target: { value } }) => this.ChangeStateField("toDateParam", value)} />
                        </div>
                    </div>

                    <div className="col-auto">
                        <button className="btn btn-outline-dark" onClick={this.CreateReferSysPromo} > <i className="fa fa-add" /> </button>
                    </div>
                </div>

                <div>
                    <GenericTable
                        headers={headers}
                        data={this.state.data}
                        view={'referSystemAdmin'}
                        enableSearchInTable={true}
                        action={this.DeleteReferSysPromo}
                    />
                </div>


            </>
        )
    }
}

export default SettingsAdmin